"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useMemoryPagination(rawItems, options = {}) {
    const items = rawItems || [];
    const { perPage = 3, enable = true } = options;
    const firstPageCount = options.firstPageCount || perPage;
    const [page, setPage] = (0, react_1.useState)(0);
    const renderCount = page === 0 ? firstPageCount : firstPageCount + page * perPage;
    return {
        items: enable ? items.slice(0, renderCount) : items,
        page: enable ? page : 0,
        hasMore: enable ? items.length > renderCount : false,
        nextPage() {
            setPage(prev => prev + 1);
        },
        prevPage() {
            setPage(prev => (prev > 0 ? prev - 1 : 0));
        },
    };
}
exports.default = useMemoryPagination;
//# sourceMappingURL=useMemoryPagination.js.map